<template>
  <div class="teaching-evaluate-apply-define-main-wrap"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="defineQuotas">
      <div class="quota">
        <div class="header">
          <div class="title">
            <span>评教指标</span>
          </div>
          <div class="extra">
            <TeachingEvaluateApplyDefineQuotaAdd :evaluation="evaluation"
                                                 :define-setup="defineSetup"
                                                 @add-success="onQuotaAddSuccess">
              <template #default="{toggleVisible}">
                <el-button size="mini"
                           type="text"
                           @click="toggleVisible">添加</el-button>
              </template>
            </TeachingEvaluateApplyDefineQuotaAdd>
          </div>
        </div>
        <div class="main">
          <div class="main-cont">
            <AppScrollbar v-if="defineQuotas.length"
                          style="height: 100%">
              <div class="quota-main">
                <Draggable v-model="defineQuotas"
                           v-bind="quotaDndOptions"
                           @end="onDragQuota"
                           class="quota-list">
                  <div v-for="defineQuota in defineQuotas"
                       :key="defineQuota.id"
                       :class="['quota-item theme-text-active theme-text-hover theme-light-bg-active', {'is-active': defineQuota === current}]"
                       :title="defineQuota.label"
                       @click="onClickQuota(defineQuota)">
                    <div class="holder">
                      <i class="el-icon-more"></i>
                    </div>
                    <div class="label">{{defineQuota.label}}</div>
                    <div class="extra"
                         @click.stop>
                      <TeachingEvaluateApplyDefineQuotaUpdate :evaluation="evaluation"
                                                              :define-setup="defineSetup"
                                                              :define-quota="defineQuota">
                        <template #default="{toggleVisible}">
                          <el-button size="mini"
                                     type="text"
                                     icon="el-icon-edit"
                                     :disabled="defineQuota.deleting"
                                     @click="toggleVisible"></el-button>
                        </template>
                      </TeachingEvaluateApplyDefineQuotaUpdate>
                      <el-button class="btn-delete"
                                 size="mini"
                                 type="text"
                                 icon="el-icon-delete"
                                 :disabled="defineQuota.deleting"
                                 @click="onDeleteQuota(defineQuota)"></el-button>
                    </div>
                  </div>
                </Draggable>
              </div>
            </AppScrollbar>
            <Hint v-else
                  :icon="false">
              <span>暂无评教指标</span>
            </Hint>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="main-cont">
          <template v-if="current">
            <TeachingEvaluateApplyDefineMainConfig :key="current.id"
                                                   :evaluation="evaluation"
                                                   :define-setup="defineSetup"
                                                   :define-quota="current"></TeachingEvaluateApplyDefineMainConfig>
          </template>
          <template v-else>
            <Hint>
              <span>请选择评教指标</span>
            </Hint>
          </template>
        </div>
      </div>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>评教指标数据加载失败</div>
        <el-button type="text"
                   @click="loadDefineQuotas">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import AppScrollbar from '../../../../../../../../elements/AppScrollbar'
import TeachingEvaluateApplyDefineQuotaAdd from '../quota-add'
import TeachingEvaluateApplyDefineQuotaUpdate from '../quota-update'
import TeachingEvaluateApplyDefineMainConfig from './config'
import Hint from '../../../../../../../../elements/Hint'
import Draggable from 'vuedraggable'
export default {
  name: 'TeachingEvaluateApplyDefineMainWrap',
  components: {
    AppScrollbar,
    TeachingEvaluateApplyDefineQuotaAdd,
    TeachingEvaluateApplyDefineQuotaUpdate,
    TeachingEvaluateApplyDefineMainConfig,
    Hint,
    Draggable
  },
  props: {
    evaluation: {
      type: Object,
      required: true
    },
    defineSetup: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      defineQuotas: null,
      current: null,
      cleaning: false,
      quotaDndOptions: {
        handle: '.quota-item .holder',
        animation: 300
      }
    }
  },
  methods: {
    loadDefineQuotas () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/teaching/evaluate/apply/define/quotas',
        method: 'post',
        data: this.$qs.stringify({
          id: this.evaluation.id,
          courseId: this.defineSetup.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.defineQuotas = response.data['defineQuotas'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleDefineClean () {
      this.$confirm('重置操作将会清除配置的“评教指标”以及“评教内容”数据，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.cleaning = true
        this.$ajax({
          url: '/workspace/manager/teaching/evaluate/apply/define/submitClean',
          method: 'post',
          data: this.$qs.stringify({
            id: this.evaluation.id,
            courseId: this.defineSetup.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                this.$set(this.defineSetup, 'isExist', false)
                this.$nextTick(() => {
                  this.defineQuotas = []
                })
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.cleaning = false
        })
      }).catch(() => {})
    },
    onQuotaAddSuccess (defineQuota) {
      if (this.defineQuotas) {
        this.defineQuotas.push(defineQuota)
      } else {
        this.loadDefineQuotas()
      }
    },
    onDeleteQuota (defineQuota) {
      this.$confirm(`确定要删除“${defineQuota.label}”评教指标吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$set(defineQuota, 'deleting', true)
        this.$ajax({
          url: '/workspace/manager/teaching/evaluate/apply/define/deleteQuota',
          method: 'post',
          data: this.$qs.stringify({
            id: this.evaluation.id,
            courseId: this.defineSetup.id,
            quotaId: defineQuota.id
          })
        }).then(response => {
          if (response.data) {
            switch (response.data['responseCode']) {
              case 'SUCCESS': {
                this.$message.success(response.data['message'])
                let defineQuotas = this.defineQuotas
                if (defineQuotas) {
                  let index = defineQuotas.findIndex(item => item.id === defineQuota.id)
                  if (index >= 0) {
                    defineQuotas.splice(index, 1)
                  }
                }
                break
              }
              default: {
                this.$message.warning(response.data['message'])
                break
              }
            }
          }
        }, () => {
          this.$message.error('请求发送失败，请稍后重试')
        }).finally(() => {
          this.$delete(defineQuota, 'deleting')
        })
      }).catch(() => {})
    },
    onClickQuota (defineQuota) {
      this.current = defineQuota
    },
    onDragQuota () {
      if (this.defineQuotas) {
        this.$nextTick(() => {
          this.$ajax({
            url: '/workspace/manager/teaching/evaluate/apply/define/sortQuota',
            method: 'post',
            data: this.$qs.stringify({
              id: this.evaluation.id,
              courseId: this.defineSetup.id,
              quotaIds: this.defineQuotas.map(item => item.id)
            }, {
              arrayFormat: 'repeat'
            })
          }).then(response => {
            if (response.data) {
              switch (response.data['responseCode']) {
                case 'SUCCESS': {
                  this.$message.success(response.data['message'])
                  break
                }
                default: {
                  this.$message.warning(response.data['message'])
                  break
                }
              }
            }
          }, () => {
            this.$message.error('请求发送失败，请稍后重试')
          })
        })
      }
    }
  },
  mounted () {
    this.loadDefineQuotas()
  },
  watch: {
    defineQuotas: function (val) {
      if (this.current) {
        if (val) {
          let getCurrent = val.find(item => item.id === this.current.id)
          if (getCurrent) {
            this.current = getCurrent
          } else {
            this.current = val[0]
          }
        } else {
          this.current = null
        }
      } else {
        if (val) {
          this.current = val[0]
        }
      }
      if (val) {
        this.$set(this.defineSetup, 'isExist', !!val.length)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../../../../../../../../../styles/color";
  .teaching-evaluate-apply-define-main-wrap {
    height: 100%;
    display: flex;
    align-items: stretch;
    & > .quota {
      flex: none;
      width: 240px;
      border-right: 1px solid #ebeef5;
      display: flex;
      flex-direction: column;
      & > .header {
        flex: none;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 9px 10px 9px 20px;
        & > .title {
          color: #909399;
          font-size: 12px;
        }
      }
      & > .main {
        flex: auto;
        position: relative;
        & > .main-cont {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          .quota-main {
            & > .quota-list {
              .quota-item {
                position: relative;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 4px 10px 4px 20px;
                cursor: pointer;
                transition: all .3s;
                & > .holder {
                  position: absolute;
                  left: 5px;
                  top: 50%;
                  width: 14px;
                  height: 14px;
                  text-align: center;
                  line-height: 14px;
                  transform: translateY(-50%);
                  margin-top: 1px;
                  cursor: move;
                  opacity: 0;
                  transition: all .3s;
                  i {
                    display: block;
                    margin-right: 0!important;
                    color: #909399;
                    font-size: 12px;
                    transform: scale(.9) rotate(90deg);
                  }
                }
                & > .label {
                  flex: auto;
                  font-size: 12px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }
                & > .extra {
                  flex: none;
                  margin-left: 10px;
                  opacity: 0;
                  transition: all .3s;
                  .el-button {
                    margin-left: 5px;
                    &.btn-delete {
                      color: $set-danger-color;
                    }
                  }
                }
                &:hover {
                  & > .holder,
                  & > .extra {
                    opacity: 1;
                  }
                }
              }
            }
          }
        }
      }
    }
    & > .main {
      flex: auto;
      position: relative;
      & > .main-cont {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
      }
    }
    .layout-hint {
      width: 100%;
    }
  }
</style>
